import { toast } from "sonner";

export function apiErrorHandler(error) {

    if (import.meta.env.DEV) {
        console.error(error)
    }
    

    const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Something went wrong. Please try again later.";

    toast.error(message)
}